import {NodeDeclChunk} from "../../chunks/types/NodeDeclChunk";
import {getNameFromIdentifierChunk} from "./getNameFromIdentifier";

export function getChildNameFromNodeDeclChunk(
  nodeDeclChunk: NodeDeclChunk
): string {
  const {
    captures: {
      1: childNameChunk
    }
  } = nodeDeclChunk;
  return getNameFromIdentifierChunk(childNameChunk);
}
